import * as React from 'react';

import { mountModal } from 'lib/modal';
import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import EventTracking from 'lib/EventTracking';
import TitleHeader from 'components/TitleHeader';
// @ts-ignore
import IndividualMessageStarter from 'chat/components/IndividualMessageStarter';
// @ts-ignore
import PotentialChatMember from 'entities/PotentialChatMember';
// @ts-ignore
import PhoneCallModal from 'phoneCalls/components/PhoneCallModal';

import './styles/MakeACallModal.scss';

type Props = {
  onRequestHide?: () => void;
};

class MakeACallModal extends React.Component<Props> {
  startCall = (pcm: PotentialChatMember) => {
    const { onRequestHide } = this.props;
    EventTracking.tap('MakeACallModal', 'select_callee');
    mountModal(<PhoneCallModal calleeUuid={pcm.getUuid()} />, this);
    if (onRequestHide) {
      onRequestHide();
    }
  };

  render() {
    return (
      <Dialog
        size="medium"
        eventScreenName="MakeACallModal"
        className="MakeACallModal"
        onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <div className="MakeACallModal-header">
            <TitleHeader
              textAlign="center"
              title="Make a voice call"
              subtext="You can contact recipients who are accepting calls on Remind"
            />
          </div>
          <IndividualMessageStarter
            onSelect={this.startCall}
            placeholderText="Type a name"
            showPhoneCallStatus
          />
        </BoxBody>
      </Dialog>
    );
  }
}

export default MakeACallModal;
